export default "__VITE_ASSET__D1twuN1E__"